export const powerMixin = {
	computed: {
		powerList() {
			if (!this.moduleName) {
				return {};
			}
			let list = {};
			let methodList = this.$storage.getSession('methodList') || {};

			let menuDataList = methodList[this.moduleName] || [];
			console.log(menuDataList);
			for (let [key, value] of Object.entries(menuDataList)) {
				list = {
					...list, ...{
						[key]: value.resourcesUrl
					}
				};
			}
			return list;
		}
	}
};

